import {
  Cancel,
  CarRepair,
  CheckCircle,
  Construction,
  Description,
  LocalGroceryStore,
  LocalMall,
} from "@mui/icons-material";
import {
  Box,
  Chip,
  SvgIcon,
  keyframes,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { translateOrderStatus, translateOrderType } from "data/functions";
import { constants } from "data/globals";
import React from "react";

export const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const SliceTextTwoRows = {
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: "2",
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "normal",
};
export const SliceTextOneRow = {
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: "1",
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "normal",
};

export const OrderChip = (props) => {
  const mobile = useMediaQuery(useTheme()?.breakpoints.down("tablet"));

  let color = props?.color
    ? props?.color
    : translateOrderStatus(props?.title) === constants.ruCANCELED ||
        translateOrderStatus(props?.title) === constants.ruDELETED
      ? "error"
      : translateOrderStatus(props?.title) === constants.ruCOMPLETED
        ? "dimgrey"
        : translateOrderStatus(props?.title) === constants.ruPAY_WAITING
          ? "secondary"
          : translateOrderStatus(props?.title) === constants.ruIN_WORK ||
              translateOrderType(props?.title) === constants.ruTypeInWay
            ? "warning"
            : translateOrderStatus(props?.title) === constants.ruREADY ||
                translateOrderStatus(props?.title) === constants.ruPAID
              ? "dimgreen"
              : "secondary";
  return (
    color && (
      <Box
        sx={{
          alignItems: "flex-end",
          display: "flex",
          flexDirection: mobile ? "column" : "row",
          gap: "4px",
          marginLeft: mobile ? "0" : "12px",
        }}
      >
        <Chip
          color={color}
          label={props?.title}
          sx={{
            "& .MuiChip-label": {
              display: "block",
              // whiteSpace: "normal",
              fontSize: "10px",
              lineHeight: "1.1",
              textAlign: "center",
            },
            height: "auto",
            // minHeight: "16px",
            // maxWidth: "80px",
            // marginTop: "-12px",
            margin: "0",
            padding: "2px",
          }}
        />
      </Box>
    )
  );
};

export const DocumentOK = (props) => {
  // style={props?.sx}
  //class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-zrw9v7-MuiSvgIcon-root"

  return (
    <SvgIcon>
      <svg
        // className=".MuiSvgIcon-root"
        fill="currentColor"
        style={props?.sx}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M11.5486 15.3404C12.0681 14.7912 12.6509 14.5455 14.2981 14.2275C15.0483 14.1505 15.2738 14.1841 16.0721 14.213C17.7319 14.2709 18.9863 14.6467 19.6199 15.2393L20 15.6151V18.1156V20.6161L19.6199 20.9919C18.2134 22.336 13.0437 22.336 11.6373 20.9919L11.2571 20.6161V18.13C11.2571 15.7307 11.2698 15.6295 11.5486 15.3404ZM19.4932 16.0198C19.4932 15.7307 18.7963 15.2971 17.9727 15.0947C15.6286 14.6248 14.8299 14.7389 13.6646 14.9646C12.993 15.0947 12.1694 15.4705 11.9414 15.7451C11.7513 15.9909 11.7386 16.0487 11.9034 16.2221C12.7143 17.0893 16.0847 17.4218 18.036 16.8292C18.7709 16.6124 19.4932 16.2077 19.4932 16.0198ZM19.3344 17.4824C19.5879 17.1933 19.5354 17.7689 19.5143 17.6487V18.1166C19.4857 18.1393 19.3977 18.2363 19.3344 18.306C19.3098 18.3331 19.289 18.356 19.2768 18.3689C18.2885 19.3951 15.1424 20.0685 12.2286 18.6045C11.9409 18.4602 11.8801 18.3636 11.7429 18.1166C11.7429 18.1166 11.7429 17.5523 11.7429 17.1406C11.7429 17.1406 12.2286 17.4824 12.7143 17.6285C13.2 17.7747 16.1143 18.6045 19.3344 17.4824ZM19.0877 20.645C19.4425 20.3992 19.4932 20.2836 19.4932 19.7633C19.4932 19.7223 19.4935 19.6839 19.4938 19.648C19.4956 19.4505 19.4966 19.3293 19.4371 19.2744C17.5397 21.0664 12.5969 19.7633 12.2286 19.5804C11.9339 19.4341 11.7961 19.5645 11.764 19.648V20.0684C11.764 20.5453 12.7354 20.9406 13.2211 21.0786C15.0457 21.6134 18.0107 21.3966 19.0877 20.645Z"
          // fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M18.5429 7.85532L12.7143 2H4.94286C3.87429 2 3.00971 2.8783 3.00971 3.95177L3 19.566C3 20.6395 3.86457 21.5177 4.93314 21.5177H10.7714V18.5901V15.7307C10.86 15.1485 11.5486 14.5965 11.5486 14.5965C11.5486 14.5965 12.2286 14.0577 14.2981 13.7106C16.3677 13.3636 18.5429 14.1188 18.5429 14.1188V7.85532ZM11.2571 9.31916L14.1714 12.2468L17.0857 9.31916H15.1217C14.6571 7.85532 14.6571 7.85532 12.2286 5.90355C13.2 7.36738 13.6857 8.34327 13.6857 9.31916H11.2571Z"
          // fill="white"
          fillRule="evenodd"
        />
      </svg>
    </SvgIcon>
  );
};
export const TrueSign = (props) => {
  // style={props?.sx}
  //class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-zrw9v7-MuiSvgIcon-root"
  return (
    <SvgIcon>
      <svg
        fill="currentColor"
        style={props?.sx}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5622 2.99775C19.9429 2.99775 20.3081 3.14853 20.5778 3.41708C20.8476 3.68563 20.9999 4.05009 21.0015 4.43068V7.99201H24V4.43068C23.9992 3.84883 23.8838 3.27284 23.6604 2.73559C23.4369 2.19833 23.1098 1.71034 22.6977 1.29947C22.2856 0.8886 21.7966 0.5629 21.2586 0.340965C20.7207 0.119031 20.1442 0.00520777 19.5622 0.00599564H15.964V3.00375L19.5622 2.99775ZM20.9955 19.5633C20.9955 19.9439 20.8447 20.309 20.5761 20.5787C20.3074 20.8484 19.9429 21.0007 19.5622 21.0022H15.964V24H19.5622C20.736 24 21.8617 23.5338 22.6917 22.704C23.5217 21.8743 23.988 20.7488 23.988 19.5753V15.978H20.9895V19.5753L20.9955 19.5633ZM3.0045 4.43068C3.00449 4.05271 3.15385 3.69005 3.42005 3.42166C3.68625 3.15328 4.04774 3.00091 4.42579 2.99775H8.02399V0H4.42579C3.84408 -5.33891e-07 3.26808 0.114646 2.73073 0.337381C2.19338 0.560117 1.70522 0.886573 1.29416 1.29808C0.883114 1.70958 0.557238 2.19806 0.335174 2.73558C0.113111 3.2731 -0.000784158 3.84912 4.06338e-06 4.43068V7.99201H2.9985L3.0045 4.43068ZM4.42579 21.0022C4.04456 21.0007 3.67939 20.8486 3.40981 20.5791C3.14023 20.3095 2.98809 19.9445 2.98651 19.5633V15.966H4.06338e-06V19.5633C0.00159068 20.7363 0.468387 21.8609 1.29804 22.6903C2.12769 23.5197 3.25249 23.9864 4.42579 23.988H8.02399V20.9903L4.42579 21.0022ZM10.2609 19.1257L3.89805 12.7345L5.98501 10.618L10.2609 14.8928L17.991 7.16463L20.09 9.28104L10.2609 19.1257Z"
          // fill="black"
        />
      </svg>
    </SvgIcon>
  );
};

export const BarcodeLocalIcon = (props) => {
  // style={props?.sx}
  //class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-zrw9v7-MuiSvgIcon-root"
  return (
    <SvgIcon>
      <svg
        fill="currentColor"
        style={props?.sx}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 21L21 3L19 3L19 21L21 21ZM17 16.0462L17 3L15 3L15 16.0462L17 16.0462ZM13 16.0462L13 3L11 3L11 16.0462L13 16.0462ZM9 16.0462L9 3L7 3L7 16.0462L9 16.0462ZM3 21L5 21L5 3L3 3L3 21Z"
          // fill="white"
        />
        <path
          d="M8.38838 20.9999C8.13057 20.9999 7.90152 20.9557 7.70124 20.8673C7.50202 20.7778 7.34541 20.6547 7.23142 20.4981C7.11743 20.3415 7.0599 20.1615 7.05884 19.958L7.95372 19.958C7.95479 20.0209 7.97397 20.0773 8.01125 20.1274C8.04961 20.1764 8.10181 20.2148 8.16786 20.2425C8.23391 20.2702 8.30955 20.284 8.39478 20.284C8.47681 20.284 8.54925 20.2696 8.6121 20.2409C8.67496 20.211 8.72397 20.17 8.75912 20.1178C8.79428 20.0656 8.81132 20.0059 8.81026 19.9388C8.81132 19.8728 8.79108 19.8142 8.74953 19.7631C8.70905 19.7119 8.65206 19.672 8.57855 19.6432C8.50504 19.6144 8.42034 19.6001 8.32446 19.6001H7.99208L7.99208 18.9864H8.32446C8.41289 18.9864 8.49066 18.972 8.55777 18.9433C8.62595 18.9145 8.67869 18.8746 8.71598 18.8234C8.75433 18.7723 8.77297 18.7137 8.77191 18.6476C8.77297 18.5837 8.75752 18.5273 8.72556 18.4782C8.6936 18.4292 8.64886 18.3909 8.59133 18.3632C8.53487 18.3355 8.46935 18.3216 8.39478 18.3216C8.31381 18.3216 8.24137 18.336 8.17745 18.3648C8.11459 18.3936 8.06505 18.4335 8.02883 18.4846C7.99261 18.5358 7.97397 18.5944 7.9729 18.6604L7.12276 18.6604C7.12382 18.4601 7.17869 18.2833 7.28735 18.1299C7.39708 17.9765 7.5473 17.8561 7.73799 17.7687C7.92869 17.6814 8.14762 17.6377 8.39478 17.6377C8.63661 17.6377 8.85021 17.6787 9.03558 17.7607C9.22201 17.8428 9.36743 17.9557 9.47184 18.0995C9.5773 18.2423 9.62951 18.4058 9.62844 18.5901C9.63057 18.7733 9.56772 18.9236 9.43988 19.0407C9.3131 19.1579 9.15223 19.2272 8.95728 19.2485V19.2741C9.22148 19.3028 9.42017 19.3838 9.55333 19.517C9.6865 19.6491 9.75202 19.8153 9.74989 20.0155C9.75095 20.2073 9.69343 20.3772 9.5773 20.5253C9.46225 20.6734 9.30191 20.7895 9.0963 20.8737C8.89176 20.9578 8.65578 20.9999 8.38838 20.9999Z"
          // fill="white"
        />
        <path
          d="M12.1386 21.0004C11.8808 21.0004 11.6518 20.9562 11.4515 20.8678C11.2523 20.7783 11.0957 20.6553 10.9817 20.4987C10.8677 20.3421 10.8101 20.162 10.8091 19.9585L11.704 19.9585C11.705 20.0214 11.7242 20.0779 11.7615 20.1279C11.7998 20.1769 11.8521 20.2153 11.9181 20.243C11.9842 20.2707 12.0598 20.2845 12.145 20.2845C12.2271 20.2845 12.2995 20.2702 12.3623 20.2414C12.4252 20.2116 12.4742 20.1705 12.5094 20.1183C12.5445 20.0661 12.5616 20.0065 12.5605 19.9394C12.5616 19.8733 12.5413 19.8147 12.4998 19.7636C12.4593 19.7124 12.4023 19.6725 12.3288 19.6437C12.2553 19.615 12.1706 19.6006 12.0747 19.6006H11.7423L11.7423 18.9869H12.0747C12.1631 18.9869 12.2409 18.9726 12.308 18.9438C12.3762 18.915 12.4289 18.8751 12.4662 18.824C12.5046 18.7728 12.5232 18.7142 12.5222 18.6482C12.5232 18.5843 12.5078 18.5278 12.4758 18.4788C12.4438 18.4298 12.3991 18.3914 12.3416 18.3637C12.2851 18.336 12.2196 18.3222 12.145 18.3222C12.0641 18.3222 11.9916 18.3366 11.9277 18.3653C11.8648 18.3941 11.8153 18.434 11.7791 18.4852C11.7429 18.5363 11.7242 18.5949 11.7231 18.661L10.873 18.661C10.8741 18.4607 10.9289 18.2838 11.0376 18.1304C11.1473 17.977 11.2975 17.8566 11.4882 17.7693C11.6789 17.6819 11.8979 17.6382 12.145 17.6382C12.3869 17.6382 12.6005 17.6792 12.7858 17.7613C12.9723 17.8433 13.1177 17.9562 13.2221 18.1001C13.3275 18.2428 13.3797 18.4063 13.3787 18.5906C13.3808 18.7739 13.318 18.9241 13.1901 19.0413C13.0633 19.1585 12.9025 19.2277 12.7075 19.249V19.2746C12.9717 19.3034 13.1704 19.3843 13.3036 19.5175C13.4367 19.6496 13.5023 19.8158 13.5001 20.0161C13.5012 20.2078 13.4437 20.3778 13.3275 20.5258C13.2125 20.6739 13.0522 20.79 12.8465 20.8742C12.642 20.9584 12.406 21.0004 12.1386 21.0004Z"
          // fill="white"
        />
        <path
          d="M15.8885 20.9999C15.6307 20.9999 15.4016 20.9557 15.2013 20.8673C15.0021 20.7778 14.8455 20.6547 14.7315 20.4981C14.6175 20.3415 14.56 20.1615 14.5589 19.958L15.4538 19.958C15.4549 20.0209 15.4741 20.0773 15.5114 20.1274C15.5497 20.1764 15.6019 20.2148 15.668 20.2425C15.734 20.2702 15.8097 20.284 15.8949 20.284C15.9769 20.284 16.0494 20.2696 16.1122 20.2409C16.1751 20.211 16.2241 20.17 16.2592 20.1178C16.2944 20.0656 16.3114 20.0059 16.3104 19.9388C16.3114 19.8728 16.2912 19.8142 16.2496 19.7631C16.2092 19.7119 16.1522 19.672 16.0787 19.6432C16.0051 19.6144 15.9205 19.6001 15.8246 19.6001H15.4922L15.4922 18.9864H15.8246C15.913 18.9864 15.9908 18.972 16.0579 18.9433C16.1261 18.9145 16.1788 18.8746 16.2161 18.8234C16.2544 18.7723 16.2731 18.7137 16.272 18.6476C16.2731 18.5837 16.2576 18.5273 16.2257 18.4782C16.1937 18.4292 16.149 18.3909 16.0914 18.3632C16.035 18.3355 15.9695 18.3216 15.8949 18.3216C15.8139 18.3216 15.7415 18.336 15.6776 18.3648C15.6147 18.3936 15.5652 18.4335 15.5289 18.4846C15.4927 18.5358 15.4741 18.5944 15.473 18.6604L14.6229 18.6604C14.6239 18.4601 14.6788 18.2833 14.7875 18.1299C14.8972 17.9765 15.0474 17.8561 15.2381 17.7687C15.4288 17.6814 15.6477 17.6377 15.8949 17.6377C16.1367 17.6377 16.3503 17.6787 16.5357 17.7607C16.7221 17.8428 16.8675 17.9557 16.9719 18.0995C17.0774 18.2423 17.1296 18.4058 17.1286 18.5901C17.1307 18.7733 17.0678 18.9236 16.94 19.0407C16.8132 19.1579 16.6523 19.2272 16.4574 19.2485V19.2741C16.7216 19.3028 16.9203 19.3838 17.0534 19.517C17.1866 19.6491 17.2521 19.8153 17.25 20.0155C17.2511 20.2073 17.1935 20.3772 17.0774 20.5253C16.9624 20.6734 16.802 20.7895 16.5964 20.8737C16.3919 20.9578 16.1559 20.9999 15.8885 20.9999Z"
          // fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export const CopiedLocalButton = (props) => {
  // style={props?.sx}
  //class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-zrw9v7-MuiSvgIcon-root"
  return (
    <SvgIcon>
      <svg
        fill="currentColor"
        style={props?.sx}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H13.5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
          // fill="black"
        />
        <path
          clipRule="evenodd"
          d="M19 21H8V7H19V21ZM9 14.2597L12.5367 18L18 12.2386L16.8333 11L12.5367 15.5228L10.16 13.0211L9 14.2597Z"
          // fill="black"
          fillRule="evenodd"
        />
      </svg>
    </SvgIcon>
  );
};

export const OrderIcon = ({ state, type }) => {
  let resIcon = <React.Fragment></React.Fragment>;
  let resState = <React.Fragment></React.Fragment>;

  switch (translateOrderType(type)) {
    case constants.ruTypeR:
      resIcon = (
        <LocalGroceryStore
          // color="dimblue"
          sx={{
            height: "1.4rem",
            margin: "0px 2px 0px 0px",
            width: "1.4rem",
          }}
        />
      );
      break;
    case constants.ruTypeZN:
      resIcon = (
        <Construction
          // color="dimblue"
          sx={{
            height: "1.3rem",
            margin: "0px 2px 0px 0px",
            width: "1.3rem",
          }}
        />
      );
      break;
    case constants.ruTypeZP:
      resIcon = (
        <LocalMall
          // color="dimblue"
          sx={{
            height: "1.4rem",
            margin: "0px 2px 0px 0px",
            width: "1.4rem",
          }}
        />
      );
      break;
    case (constants.ruTypeZR, constants.ruTypeManu):
      resIcon = (
        <CarRepair
          // color="dimblue"
          sx={{
            height: { mobile: "1.4rem", tablet: "1.6rem" },
            margin: "0px 4px 0px 0px",
            width: { mobile: "1.4rem", tablet: "1.6rem" },
          }}
        />
      );
      break;

    default:
      resIcon = (
        <Description
          // color="dimblue"
          sx={{
            height: { mobile: "1.4rem", tablet: "1.6rem" },
            margin: "0px 4px 0px 0px",
            width: { mobile: "1.4rem", tablet: "1.6rem" },
          }}
        />
      );
      break;
  }

  switch (state) {
    case "ПРОВЕДЕН":
      resState = (
        <CheckCircle
          sx={{
            // border: "-1px solid green",
            // borderRadius: "90%",
            fill: "green",
            height: "0.8rem",
            path: {
              fill: "green",
            },
            width: "0.8rem",
          }}
        />
      );
      break;
    case "УДАЛЕН":
      resState = (
        <Cancel sx={{ fill: "red", height: "0.8rem", width: "0.8rem" }} />
      );
      break;

    default:
      break;
  }
  return (
    <React.Fragment>
      <Box sx={{ position: "relative" }}>
        {resIcon}{" "}
        {state && (
          <Box sx={{ bottom: "-2px", position: "absolute", right: "5px" }}>
            {resState}
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};
